export default __webpack_public_path__ + "static/media/checklistHigh.c487daad.png";